module.exports = __webpack_public_path__ + "img/trainingVideo.efe77a58.png";